import type { FC, ReactNode } from 'react'

import { BrandMark } from '@/components/generals/brand-mark'
import { Marquee } from '@/components/generals/marquee'
import { ContactForm } from '@/components/landing/contact-form'

const WORD_COPIES = 2

export const ContactSection: FC = (): ReactNode => {
    return (
        <section id='contact' aria-labelledby='contact-title' className='w-full bg-background px-4 md:px-8'>
            <div className='mx-auto w-full max-w-site py-12 md:py-16 lg:py-20'>
                <div className='relative isolate overflow-hidden rounded-panel bg-aurora text-primary-foreground'>
                    <div className='flex flex-col items-center gap-4 py-12 text-center'>
                        <BrandMark className='size-20 md:size-[6.25rem]' />

                        <h2 id='contact-title' className='sr-only'>
                            Contact
                        </h2>

                        <div className='relative mb-5 w-full overflow-hidden text-left' aria-hidden='true'>
                            <div className='-mb-2.5 pl-10 md:-mb-5'>
                                <Marquee duration={WORD_COPIES * 25}>
                                    {Array.from({ length: WORD_COPIES }, (_, index) => (
                                        <span
                                            key={index}
                                            className='pr-5 font-heading text-mega font-medium whitespace-nowrap text-inherit md:pr-10 lg:pr-[4.3rem]'
                                        >
                                            - Contact
                                        </span>
                                    ))}
                                </Marquee>
                            </div>
                        </div>

                        <div className='mx-auto flex w-full max-w-[44rem] flex-col items-center gap-6 px-4 md:gap-8 md:px-8'>
                            <p className='text-base leading-[1.3] text-balance opacity-70'>
                                Connecting with me can transform your ideas into reality. Let&apos;s collaborate and create something extraordinary together, whether through inquiries or personal consultations.
                            </p>

                            <ContactForm />
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}
